/** A bounded read loop; callers supply read-only repository operations. */
export function createReadRefresh<T>({ read, apply, failed, enabled, interval = 30_000, now = Date.now, clock = { next: 0, failures: 0 } }: {
  read: () => Promise<T>; apply: (value: T) => void; failed: (error: unknown) => void;
  enabled: () => boolean; interval?: number; now?: () => number; clock?: { next: number; failures: number };
}) {
  let disposed = false, busy = false;
  return {
    async run() {
      if (disposed || busy || !enabled() || now() < clock.next) return;
      busy = true; clock.next = now() + interval;
      try {
        const value = await read();
        if (!disposed && enabled()) { clock.failures = 0; apply(value); }
      } catch (error) {
        if (!disposed) { clock.failures++; clock.next = now() + Math.min(120_000, interval * 2 ** clock.failures); if (enabled()) failed(error); }
      } finally { busy = false; }
    },
    dispose() { disposed = true; },
  };
}
